<script setup lang="ts">
import { EditIcon } from "../Icons";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";

export interface TcMenuPencilItemProps {
  label: string;
  color?: colorTag;
  showIcon?: boolean;
}

withDefaults(defineProps<TcMenuPencilItemProps>(), {
  color: "content-high",
  showIcon: true,
});
</script>

<template>
  <li class="list-item">
    <p class="label">{{ label }}</p>
    <EditIcon v-if="showIcon" :color="color" />
  </li>
</template>

<style scoped lang="scss">
.list-item {
  @include border(1, solid, b);
  @include colors.border(primary, low);
  @include colors.bg(background, base);
  @include sp.padding(y, 0);
  @include sp.padding(x, 4);

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  cursor: pointer;
  font-family: $ts-figtree-regular-font;
  min-height: $size-menu-item-height;

  .label {
    @include text.general(low, l);
    @include colors.color(content, high);
    @include text.modification(ellipsis);

    flex-grow: 1;
  }
}
</style>
